import { render, staticRenderFns } from "./ProductionStat.view.vue?vue&type=template&id=7c24bbb1&"
import script from "./ProductionStat.view.vue?vue&type=script&lang=js&"
export * from "./ProductionStat.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports